module.exports = __webpack_public_path__ + "img/videos.c30f7e3c.svg";